import ApiCore from './api-core'
import { PUBLIC } from '@/constants/api-types'

export default class Otp extends ApiCore {
  constructor(store) {
    const path = `${PUBLIC}/otp`
    super(store, path)
  }

  send(operation, model, showProgress) {
    return this.request({
      action: 'send',
      method: 'POST',
      params: { operation },
      body: model,
      showProgress
    })
  }
}
